/**
 * HTML escaping for text interpolated into innerHTML templates — element
 * content and quoted attribute values alike. Use it for anything that came
 * from input, storage or a URL.
 */
const ENTITIES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, (ch) => ENTITIES[ch]);
}

/** Astrological glyphs (planets, signs) shown as text, never as emoji: the text variation selector after each. */
export const textGlyphs = (value) => String(value).replace(/([\u2609\u263D\u263E\u263F\u2640\u2642-\u2644\u2648-\u2653])(?!\uFE0E)/g, '$1\uFE0E');

/** A quoted printed text, escaped, its italics marked *…* in the data set in italics, its glyphs as text. */
export const printedText = (value) => textGlyphs(escapeHtml(value)).replace(/\*([^*]+)\*/g, '<i>$1</i>');
